import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testm',
  templateUrl: './testm.component.html',
  styleUrls: ['./testm.component.css']
})
export class TestmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
